import { FIELD_BIND_TYPE, FIELD_BIND_TYPE_ENUM } from './tables'

export const MIN_LABEL_WIDTH = 120
export const MAX_LABEL_HEIGHT = 60
export const MAX_INPUT_LENGTH = 5000
export const MAX_INPUT_VALUE_MINUTES = 999

export const FIELD_BIND_VALUE_TYPE_OPTIONS = [
  { id: FIELD_BIND_TYPE_ENUM.FIELD, label: FIELD_BIND_TYPE.FIELD },
  { id: FIELD_BIND_TYPE_ENUM.STATIC, label: FIELD_BIND_TYPE.STATIC },
  { id: FIELD_BIND_TYPE_ENUM.JS, label: FIELD_BIND_TYPE.JS },
]
